import computed from './computed'
import data from './data'
import components from './components'
import mounted from './mounted'

export default {
  computed,
  data,
  components,
  mounted,
  resourcePath: '/v1/dweller/rent/unit'
}



// WEBPACK FOOTER //
// ./src/app/dweller/rental/resources/index.js